import { FC } from 'react';
import { Info } from 'lucide-react';

type StepMessageVariant = 'info' | 'warning';

interface StepMessageProps {
  message: string;
  variant?: StepMessageVariant;
}

const STEP_MESSAGE_STYLES = {
  info: {
    backgroundColor: 'bg-(--primary-O200)',
    textColor: 'text-(--primary-O1000)',
    iconColor: 'text-(--primary-O1000)',
  },
  warning: {
    backgroundColor: 'bg-(--warning-W100)',
    textColor: 'text-(--warning-W700)',
    iconColor: 'text-(--warning-W700)',
  },
};

export const StepMessage: FC<StepMessageProps> = ({ message, variant = 'warning' }) => {
  const styles = STEP_MESSAGE_STYLES[variant];

  return (
    <div className={`w-full inline-flex gap-3 rounded-xl px-5 py-4 ${styles.backgroundColor}`}>
      <Info className={`shrink-0 ${styles.iconColor} w-5 h-5 lg:w-6 lg:h-6`} />
      <p
        className={`m-0! [font-size:var(--fs-l4)]! lg:[font-size:var(--fs-p3)]! font-medium leading-tight ${styles.textColor}`}
      >
        {message}
      </p>
    </div>
  );
};
